/**
 * Stateshot.js
 * (c) 2018 Yifeng Wang
 */
import { History } from './history'

window.History = History
